<template>
  <div class="w-full mx-auto top-0 min-w-0 min-h-0 overflow-hidden"
    v-if="user">
    <dashboard-heading :name="user.name" :photo="user.urlProfilePhoto"
      :isTeacher="true"/>
    <div class="flex flex-col md:flex-row w-full min-h-screen">
      <section class="w-full px-3 lg:px-0 bg-white z-10 flex shadow min-h-screen">
        <div class="flex flex-col lg:pl-0 md:pl-4 w-full">
          <profile-nav :dashboardPath="dashboardPath" :profilePic="user.urlProfilePhoto" />
          <router-view></router-view>
        </div>
      </section>
      <!--<div class="w-full">
        <div id="buttons"
          class="flex flex-col md:flex-row w-2/3 mx-auto md:justify-center mt-16">
          <router-link to="/dashboard/calendar">
            <dashboard-button
              :buttonPlaceholder="$t('dashboard.calendar')"
              class="mt-4 md:mt-0" />
          </router-link>
        </div>

        <div class="flex justify-center w-full mt-10">
          <next-booked-lessons
            :slots="checkedBookedSlots"
            :title="$t('bookedLessonsDashboard.title')"
            :isStudent="false"
            @startLesson="startLesson($event)" />
        </div>

        <div class="flex flex-col md:flex-row mt-20 w-full mx-auto" v-if="studentSlots.length>0">
          <next-booked-lessons
            :slots="checkedStudentSlots"
            :title="$t('bookedLessonsDashboard.title2')"
            :isStudent="true"
            @startLesson="startLessonAsStudent($event)" />
        </div>

      </div>-->
    </div>
    <modal resizable name="timezone" />
  </div>
</template>

<style>
  .vm--modal{
    height: auto !important;
  }
</style>

<script>
import { mapActions, mapGetters } from 'vuex';
import TimezoneForm from '@/components/TimezoneForm.vue';
// import PricesList from '@/components/PricesList.vue';
// import DashboardButton from '@/components/DashboardButton.vue';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import DatesConversion from '@/mixins/DatesConversion';
// import TeacherRates from '@/components/teachers/TeacherRates.vue';
// import dayjs from 'dayjs';
// import NextBookedLessons from '../components/NextBookedLessons.vue';
import DashboardHeading from '../components/graphics/DashboardHeading.vue';
import ProfileNav from '../components/graphics/ProfileNav.vue';

export default {
  data() {
    return {
      all: false,
      number: 5,
      colorfulHarps: 0,
      halfColorHarps: 0,
      grayHarps: 0,
    };
  },

  components: {
    DashboardHeading,
    ProfileNav,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      dashboardPath: 'auth/dashboardPath',
      choosenTimezone: 'timezone/choosenTimezone',
      teacher: 'auth/teacher',
    }),

    textColor() {
      if (this.isTeacher) {
        return 'beige-academy-300';
      }
      return 'orange-academy-300';
    },
    notificationsChannel() {
      return `App.Teacher.${this.teacher.id}`;
    },
    notifiableType() {
      return 'App\\Teacher';
    },
    notifiableId() {
      return this.teacher.id;
    },
  },

  mixins: [StreamFunctionsMixin, DatesConversion],

  created() {
    window.Echo.private(this.notificationsChannel)
      .notification((notification) => {
        this.addNotification({
          ...notification,
          notifiableId: this.notifiableId,
          notifiableType: this.notifiableType,
        });
      });
  },

  mounted() {
    if (!this.user.timezone) {
      this.setUserTimezone();
    }
  },

  methods: {
    ...mapActions({
      saveTimezone: 'auth/saveTimezone',
      addNotification: 'notifications/addFromPusher',
    }),

    chooseTimezone() {
      this.$modal.show(TimezoneForm, {}, {
        adaptive: true, height: 'auto',
      });
    },

    openCalendar() {
      this.$router.push({ path: '/dashboard/calendar' }).catch(() => {});
    },

    setRate() {
      this.colorfulHarps = this.getTeacherRate(this.user.teacher.stars_avg).colorfulHarps;
      this.halfColorHarps = this.getTeacherRate(this.user.teacher.stars_avg).halfColorHarps;
      this.grayHarps = this.getTeacherRate(this.user.teacher.stars_avg).grayHarps;
    },

    setUserTimezone() {
      this.saveTimezone(this.choosenTimezone).then(() => {
        this.$store.dispatch('auth/me');
      });
    },

    /* getBookedLessons() {
      const now = dayjs.utc();
      now.subtract(15, 'm');
      const startDate = this.changeDateFormatForCalendarAndDatabase(now);
      axios.get(`/api/teachers/${this.user.teacher.id}/booked?startDate=${startDate}`)
      .then((response) => {
        response.data.forEach((slot) => {
          const newSlot = this.convertBookedSlotToBePrintedOnDashboard(slot, 'teacher');
          newSlot.student_id = slot.student_id;

          if (!this.bookedSlots.some(
            (existingSlot) => existingSlot.id === newSlot.id,
          )) {
            this.bookedSlots.push(newSlot);
          }
        });
      }).catch((errors) => {
        console.log(errors);
      });
    },

    getStudentBookedLessons() {
      const now = dayjs.utc();
      now.subtract(15, 'm');
      const startDate = this.changeDateFormatForCalendarAndDatabase(now);
      return axios.get(`/api/students/${this.user.student.id}/slots?startDate=${startDate}`)
      .then((response) => {
        response.data.forEach((slot) => {
          const newSlot = this.convertBookedSlotToBePrintedOnDashboard(slot, 'student');
          if (!this.studentSlots.some(
            (existingSlot) => existingSlot.id === newSlot.id,
          )) {
            this.studentSlots.push(newSlot);
          }
        });
      }).catch((errors) => {
        console.log(`Lettura slots prenotati fallita: ${errors}`);
      });
    }, */

  },
};
</script>

<style scoped lang="scss">
  .dashboard {
    height: 58vh;

  }
  .shadowColorMobile {
    --tw-shadow: 0 10px 15px 3px rgb(0, 0, 0),
      0 10px 6px 2px rgb(77, 71, 71);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(235, 98, 98, 0)),
      var(--tw-ring-shadow, 0 0 rgba(243, 93, 93, 0)), var(--tw-shadow);
  }
  .shadowColor {
    --tw-shadow: 0 10px 10px -3px rgb(0, 0, 0),
      0 0px 6px -2px rgb(77, 71, 71);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(235, 98, 98, 0)),
      var(--tw-ring-shadow, 0 0 rgba(243, 93, 93, 0)), var(--tw-shadow);
  }
</style>
